import { Fragment } from 'react';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Column } from '~/commonComponents';
import { UserProfession } from '~/enums/UserProfession';
import { IJob, IUser, ProfessionTypeEnum } from '~/models';
import { TNullable } from '~/types/Nullable';

interface IDnDaProceduresProps {
  job: TNullable<IJob>;
  professional: TNullable<IUser>;
}

export const DnDaProcedures = ({ job, professional }: IDnDaProceduresProps) => {
  const candidateEducation = professional?.professional_info?.education;
  const candidateProfession = professional?.license?.profession;
  const profession = (job?.profession || candidateProfession) as ProfessionTypeEnum;

  return (
    [UserProfession.DN, UserProfession.DA].includes(profession) && (
      <Column gap={16} marginTop={12}>
        {Object.keys(candidateEducation?.[profession]?.specialtiesAndProcedures || {})?.map(
          (name) => (
            <Fragment key={name}>
              <Typography as="span" bold color={colors.primary[500]} size="body_large" id={name}>
                {name?.split('_')?.[1]}
              </Typography>

              <Column gap={4} marginTop={8}>
                {candidateEducation?.[profession]?.specialtiesAndProcedures?.[name]?.map((item) => (
                  <Typography as="span" key={item}>{`\u2022  ${item?.split('_')?.[1]}`}</Typography>
                ))}
              </Column>
            </Fragment>
          ),
        )}
      </Column>
    )
  );
};
